export const BittsBoneType = {
  Avatar: 'avatar',
  Heading: 'heading',
  Copy: 'copy',
} as const;
export type IBittsBoneType = (typeof BittsBoneType)[keyof typeof BittsBoneType];
